// extracted by mini-css-extract-plugin
module.exports = {"header-bg-image":"g","headerBgImage":"g","header-bg":"h","headerBg":"h"};